import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { SearchClientService } from '@mode/algolia/domain';
import {
  AlgoliaSuggestionService,
  OpenSearchSuggestionService,
} from '~/plugins/ace/completion-providers/suggestion.service';

export const DowngradedSharedDataAccessAlgoliaModule = angular
  .module('downgraded-shared-data-access-algolia', [])
  .service('AlgoliaSuggestionService', downgradeInjectable(AlgoliaSuggestionService))
  .service('OpenSearchSuggestionService', downgradeInjectable(OpenSearchSuggestionService))
  .service('SearchClientService', downgradeInjectable(SearchClientService)).name;
